import React, { useState } from 'react'
import { Button, IconButton } from '@mui/material'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useSnackbar } from 'notistack';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useSubmitLock from '../../../hooks/useSubmitLock';

const { REACT_APP_API_URL } = process.env;

const EliminarLote = (props) => {

    const { data } = props
    const { obtenerloteact } = props
    const { lote } = props

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const { enqueueSnackbar } = useSnackbar();
    const { submitting, runWithSubmitLock } = useSubmitLock();

    const handleClickVariant = (resultado) => {
        const variant = resultado.variant
        const msg = resultado.errores || resultado.msg
        enqueueSnackbar(msg, { variant });
    };


    const eliminarlote = (e) => runWithSubmitLock(async () => {
        const token = sessionStorage.getItem('%t')
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            idlote: e
        });
        var requestOptions = {
            method: 'DELETE',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
        try {
            const response = await fetch(`${REACT_APP_API_URL}/lotes`, requestOptions)
            const resultado = await response.json();
            return (handleClickVariant(resultado), obtenerloteact(), setOpen(false))
        } catch (error) {
            console.log('Algo salio mal', error);
        }
    })


    return (<>
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {"¿Estas seguro de eliminar?"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Lote:  {lote}
                </DialogContentText>
                <DialogContentText id="alert-dialog-description">
                    No empleados:  {data.no_empleados}
                </DialogContentText>
                <DialogContentText id="alert-dialog-description">
                    Depta:  {data.descdepto}
                </DialogContentText>
                <DialogContentText id="alert-dialog-description">
                    Periodo:  {data.numeroperiodo}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant='contained' color='success' disabled={submitting} onClick={e => eliminarlote(lote)}>Aceptar</Button>
                <Button onClick={handleClose} autoFocus>
                    Cancelar
                </Button>
            </DialogActions>
        </Dialog>
        <IconButton onClick={handleClickOpen}>
            <DeleteForeverIcon />
        </IconButton>
    </>
    )


}

export default EliminarLote
